import type { Task } from "~skillBuilder/utils/types";

export const AzMrtOverview = {
  name: "Overview",
  uniqueName: "az-mrt-overview",
  icon: "Overview",
  durationTimeText: "2 min",
  isIntro: true,
  steps: [
    // Step 1
    {
      nextButtonText: "Start Lesson",
      questions: [
        // Question 1.1
        {
          attribute: "az-mrt/overview",
          label: "Arizona Mandated Reporter Training (AZ Subs Only)",
          // description: "",
          answerType: {
            type: "CONTENT",
            value: "valid",
            markdown: `

**This is only applicable to subs in Arizona and only fulfills the Mandated Reporter Training for Arizona.** 

This training is designed to help you understand your legal obligations under Arizona law (A.R.S. § 13-3620). As substitute teachers, you play a vital role in protecting children. This training equips you with the knowledge to recognize signs of abuse and neglect and to fulfill your legal duty to report.

**Training Objectives**

By the end of this training, you will understand your legal obligations as a mandated reporter in Arizona. You'll learn how to recognize potential signs of abuse and neglect, know when and how to make a report, understand the reporting process, be aware of your legal protections, and be able to apply this knowledge in your role as a substitute teacher.

<ul style="margin-left: 16px;">
<li>⚖️ <strong>Understand Arizona's mandated reporter laws:</strong> Learn the legal expectations outlined by A.R.S. § 13-3620 and why your role matters.</li>
<li>👁️ <strong>Recognize signs of child abuse and neglect:</strong> Identify physical, emotional, and behavioral indicators of maltreatment.</li>
<li>📞 <strong>Know when and how to report suspected abuse:</strong> Learn the proper channels and required information for making a report.</li>
<li>🔄 <strong>Understand the step-by-step reporting process:</strong> Follow the protocol clearly and confidently from concern to report.</li>
<li>🛡️ <strong>Know your legal protections and responsibilities:</strong> Understand your protections and obligations as a reporter.</li>
<li>🧑‍🏫 <strong>Apply this knowledge in your role as a substitute teacher:</strong> Real-life classroom scenarios will help you put theory into practice.</li>
</ul>

This training covers all required elements under ARS 15-712.02:

<ul style="margin-left: 16px;">
<li>How to recognize risk factors and warning signs of abuse</li>
<li>Internal procedures for children to seek help</li>
<li>Methods for reducing risk</li>
<li>Step-by-step reporting process for substitute teachers</li>
</ul>

Our goal is to equip you with the tools to recognize and report concerns confidently, responsibly, and legally. Everything here is aligned with Arizona's regulations—because protecting children starts with knowing what to look for and what to do.
`,
          },
        },
      ],
    },
  ],
} as const satisfies Task;
